"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementIdException = void 0;
class ElementIdException extends Error {
    constructor(id) {
        super(`The element with the id ${id} was not found, please enter a valid id element.`);
    }
}
exports.ElementIdException = ElementIdException;
